export default __webpack_public_path__ + "static/mobile-screen-e593a7e77384b2e11a753b7dda985df2.png";